module.exports = __webpack_public_path__ + "img/bg.9433f433.png";